import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-173e92ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "control top" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 対局 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 中断 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 投了 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 検討 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 検討終了 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 局面編集 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 局面編集終了 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 手番変更 ")
const _hoisted_10 = { class: "control bottom" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" アプリ設定 ")
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" エンジン設定 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 盤面反転 ")
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 棋譜貼り付け ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 棋譜コピー ")
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 指し手削除 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_BoardView = _resolveComponent("BoardView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BoardView, {
      "piece-image-type": _ctx.pieceImageType,
      "board-image-type": _ctx.boardImageType,
      "max-size": _ctx.maxSize,
      position: _ctx.position,
      "last-move": _ctx.lastMove,
      flip: _ctx.flip,
      "allow-move": _ctx.allowMove,
      "allow-edit": _ctx.allowEdit,
      "black-player-name": _ctx.blackPlayerName,
      "white-player-name": _ctx.whitePlayerName,
      "black-player-time-ms": _ctx.blackPlayerTimeMs,
      "black-player-byoyomi": _ctx.blackPlayerByoyomi,
      "white-player-time-ms": _ctx.whitePlayerTimeMs,
      "white-player-byoyomi": _ctx.whitePlayerByoyomi,
      onMove: _ctx.onMove,
      onEdit: _ctx.onEdit
    }, {
      "right-control": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.controlStates.game)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGame && _ctx.onGame(...args)))
              }, [
                _createVNode(_component_ButtonIcon, {
                  class: "icon",
                  icon: "game"
                }),
                _hoisted_2
              ]))
            : _createCommentVNode("", true),
          (_ctx.controlStates.stop)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onStop && _ctx.onStop(...args)))
              }, [
                _createVNode(_component_ButtonIcon, {
                  class: "icon",
                  icon: "stop"
                }),
                _hoisted_3
              ]))
            : _createCommentVNode("", true),
          (_ctx.controlStates.resign)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onResign && _ctx.onResign(...args)))
              }, [
                _createVNode(_component_ButtonIcon, {
                  class: "icon",
                  icon: "resign"
                }),
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          (_ctx.controlStates.research)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onResearch && _ctx.onResearch(...args)))
              }, [
                _createVNode(_component_ButtonIcon, {
                  class: "icon",
                  icon: "research"
                }),
                _hoisted_5
              ]))
            : _createCommentVNode("", true),
          (_ctx.controlStates.endResearch)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onEndResearch && _ctx.onEndResearch(...args)))
              }, [
                _createVNode(_component_ButtonIcon, {
                  class: "icon",
                  icon: "end"
                }),
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (_ctx.controlStates.startEditPosition)
            ? (_openBlock(), _createElementBlock("button", {
                key: 5,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onStartEditPosition && _ctx.onStartEditPosition(...args)))
              }, [
                _createVNode(_component_ButtonIcon, {
                  class: "icon",
                  icon: "edit"
                }),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          (_ctx.controlStates.endEditPosition)
            ? (_openBlock(), _createElementBlock("button", {
                key: 6,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onEndEditPosition && _ctx.onEndEditPosition(...args)))
              }, [
                _createVNode(_component_ButtonIcon, {
                  class: "icon",
                  icon: "check"
                }),
                _hoisted_8
              ]))
            : _createCommentVNode("", true),
          (_ctx.controlStates.initPosition)
            ? (_openBlock(), _createElementBlock("button", {
                key: 7,
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onChangeTurn && _ctx.onChangeTurn(...args)))
              }, [
                _createVNode(_component_ButtonIcon, {
                  class: "icon",
                  icon: "swap"
                }),
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          (_ctx.controlStates.initPosition)
            ? (_openBlock(), _createElementBlock("button", {
                key: 8,
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onInitPositionStandard && _ctx.onInitPositionStandard(...args)))
              }, " 平手 "))
            : _createCommentVNode("", true),
          (_ctx.controlStates.initPosition)
            ? (_openBlock(), _createElementBlock("button", {
                key: 9,
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onInitPositionTsumeShogi && _ctx.onInitPositionTsumeShogi(...args)))
              }, " 詰将棋 "))
            : _createCommentVNode("", true)
        ])
      ]),
      "left-control": _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            disabled: !_ctx.controlStates.appSettings,
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onOpenAppSettings && _ctx.onOpenAppSettings(...args)))
          }, [
            _createVNode(_component_ButtonIcon, {
              class: "icon",
              icon: "settings"
            }),
            _hoisted_12
          ], 8, _hoisted_11),
          _createElementVNode("button", {
            disabled: !_ctx.controlStates.engineSettings,
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onOpenEngineSettings && _ctx.onOpenEngineSettings(...args)))
          }, [
            _createVNode(_component_ButtonIcon, {
              class: "icon",
              icon: "engineSettings"
            }),
            _hoisted_14
          ], 8, _hoisted_13),
          _createElementVNode("button", {
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onFlip && _ctx.onFlip(...args)))
          }, [
            _createVNode(_component_ButtonIcon, {
              class: "icon",
              icon: "flip"
            }),
            _hoisted_15
          ]),
          _createElementVNode("button", {
            disabled: !_ctx.controlStates.paste,
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args)))
          }, [
            _createVNode(_component_ButtonIcon, {
              class: "icon",
              icon: "paste"
            }),
            _hoisted_17
          ], 8, _hoisted_16),
          _createElementVNode("button", {
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onCopy && _ctx.onCopy(...args)))
          }, [
            _createVNode(_component_ButtonIcon, {
              class: "icon",
              icon: "copy"
            }),
            _hoisted_18
          ]),
          _createElementVNode("button", {
            disabled: !_ctx.controlStates.removeAfter,
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onRemoveAfter && _ctx.onRemoveAfter(...args)))
          }, [
            _createVNode(_component_ButtonIcon, {
              class: "icon",
              icon: "delete"
            }),
            _hoisted_20
          ], 8, _hoisted_19)
        ])
      ]),
      _: 1
    }, 8, ["piece-image-type", "board-image-type", "max-size", "position", "last-move", "flip", "allow-move", "allow-edit", "black-player-name", "white-player-name", "black-player-time-ms", "black-player-byoyomi", "white-player-time-ms", "white-player-byoyomi", "onMove", "onEdit"])
  ]))
}